import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC, useEffect, useState } from 'react'
import Modal from '../common/Modal'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'
import { TEMPLATE_LIST_1, TEMPLATE_LIST_2 } from '../../constants/taskTemplate'
import { useHistory } from 'react-router-dom'
import { setPath } from '../../../utils/url'
import { URL } from '../../constants/url'
import LoadingSquare from '../common/LoadingSquare'
import { RequestGetTaskProjectTemplateSetting } from '../../../states/types/task'
import { fetchTaskProjectTemplateSetting } from '../../../states/containers/task/taskSlice'

interface TemplateDetail {
  id?: number
  name: string
  color?: string
  code?: string
  description?: string
  permission: {
    viewable: {
      teams: {
        id: number
        name: string
      }[]
      members: {
        id: number
        name: string
      }[]
    }
    usable: {
      teams: {
        id: number
        name: string
      }[]
      members: {
        id: number
        name: string
      }[]
    }
  }
  labels: {
    name: string
  }[]
}

interface Props {
  closeCallback: VoidFunction
  addCallback: (state: { detail?: TemplateDetail | null, labelGroupId?: number, templateId?: number }) => void
  deleteCallback?: (id: number, name: string) => void
  importCallback: () => void
  isDisplay: boolean
}

const CreateProjectModal: FC<Props> = (props) => {
  const {
    closeCallback,
    addCallback,
    deleteCallback,
    importCallback,
    isDisplay,
  } = props

  const {
    task,
  } = useSelector((state: RootState) => state)

  const history = useHistory()
  const dispatch = useDispatch()

  const [step, setStep] = useState<string>("select")
  const [selectList, setSelectList] = useState<TemplateDetail[]>([])

  const [isLoading, setIsLoading] = useState<boolean>(true)

  const close = () => {
    setStep("select")
    closeCallback()
  }

  const clickSelect = (detail: TemplateDetail) => {
    if (step === "category_1" || step === "category_2" || step === "custom") {
      addCallback({ detail: detail })
      return
    }
    if (step === "copy") {
      addCallback({ labelGroupId: detail.id })
    }
  }

  const clickPrev = () => {
    if (step === "category_1" || step === "category_2") {
      setStep("generic")
      return
    }
    setStep("select")
  }

  const createTemplate = () => {
    history.push({
      pathname: `${setPath(URL.TASK_PROJECT_TEMPLATE_SETTING_CREATE.path, "ja")}`,
    })
  }

  const deleteTemplate = (id: number, name: string) => {
    if (!deleteCallback) return
    deleteCallback(id, name)
  }

  useEffect(() => {
    if (step === "select") {
      setSelectList([])
      return
    }
    if (step === "category_1") {
      setSelectList(TEMPLATE_LIST_1)
      setIsLoading(false)
      return
    }
    if (step === "category_2") {
      setSelectList(TEMPLATE_LIST_2)
      setIsLoading(false)
      return
    }
    if (step === "custom") {
      setIsLoading(true)
      const params: RequestGetTaskProjectTemplateSetting = {
        limit: 1000,
      }
      dispatch(
        fetchTaskProjectTemplateSetting(
          params,
        ),
      )
      return
    }
    if (step === "copy") {
      setSelectList(
        task.taskLabelSetting?.label_groups.map((v) => (
          {
            id: v.id,
            name: v.name,
            permission: v.permission,
            labels: v.labels,
          }
        )) || [],
      )
      setIsLoading(false)
    }
  }, [step])

  useEffect(() => {
    if (step !== "custom") return
    setSelectList(
      task.taskProjectTemplateSetting?.label_group_templates.map((v) => (
        {
          id: v.id,
          name: v.name,
          color: v.color,
          code: v.code || "",
          description: v.description || "",
          permission: v.permission,
          labels: v.labels,
        }
      )) || [],
    )
    setIsLoading(false)
  }, [task.taskProjectTemplateSetting?.label_group_templates])

  return (
    <Modal
      show={isDisplay}
      wrapperClass="create_project_modal"
      closeCallback={close}
      closeable
    >
      <>
        {
          step === "select" && (
            <>
              <div className="select_type_wrapper">
                <button
                  type="button"
                  onClick={() => addCallback({ detail: null })}
                  className="new"
                >
                  <div className="type_icon_area">
                    <FontAwesomeIcon icon={['fas', 'edit']} />
                  </div>
                  <div className="type_text_area">
                    すべて入力して作成する
                  </div>
                </button>
                <button
                  type="button"
                  onClick={() => setStep("generic")}
                  className="generic"
                >
                  <div className="type_icon_area">
                    <FontAwesomeIcon icon={['fas', 'object-group']} />
                  </div>
                  <div className="type_text_area">
                    <div>
                      汎用テンプレートから
                    </div>
                    <div>
                      選択して作成する
                    </div>
                  </div>
                </button>
                <button
                  type="button"
                  onClick={() => setStep("custom")}
                  className="custom"
                >
                  <div className="type_icon_area">
                    <FontAwesomeIcon icon={['fas', 'chalkboard-teacher']} />
                  </div>
                  <div className="type_text_area">
                    <div>
                      ユーザーテンプレートから
                    </div>
                    <div>
                      選択して作成する
                    </div>
                  </div>
                </button>
                <button
                  type="button"
                  onClick={importCallback}
                  className="csv"
                >
                  <div className="type_icon_area">
                    <FontAwesomeIcon icon={['fas', 'file-csv']} />
                  </div>
                  <div className="type_text_area">
                    <div>
                      CSVファイルで
                    </div>
                    <div>
                      まとめて作成する
                    </div>
                  </div>
                </button>
              </div>
            </>
          )
        }
        {
          step === "generic" && (
            <>
              <button
                type="button"
                onClick={clickPrev}
                style={{
                  fontSize: "11px",
                }}
              >
                &lt; ひとつ前へ戻る
              </button>
              <div className="select_type_wrapper">
                <button
                  type="button"
                  onClick={() => setStep("category_2")}
                  className="occupation"
                >
                  <div className="type_icon_area">
                    <FontAwesomeIcon icon={['fas', 'walking']} />
                  </div>
                  <div className="type_text_area">
                    <div>
                      職種ベースで
                    </div>
                    <div>
                      プロジェクトを作成する
                    </div>
                  </div>
                </button>
                <button
                  type="button"
                  onClick={() => setStep("category_1")}
                  className="case"
                >
                  <div className="type_icon_area">
                    <FontAwesomeIcon icon={['fas', 'scroll']} />
                  </div>
                  <div className="type_text_area">
                    <div>
                      案件ベースで
                    </div>
                    <div>
                      プロジェクトを作成する
                    </div>
                  </div>
                </button>
              </div>
            </>
          )
        }
        {
          (step === "category_1" || step === "category_2" || step === "custom" || step === "copy") && (
            <>
              <button
                type="button"
                onClick={clickPrev}
                style={{
                  fontSize: "11px",
                }}
              >
                &lt; ひとつ前へ戻る
              </button>
              {
                isLoading ? (
                  <>
                    <LoadingSquare>
                      <>
                        テンプレートリストを読み込んでいます…
                      </>
                    </LoadingSquare>
                  </>
                ) : (
                  <>
                    <div className="template_list">
                      <>
                        {
                          selectList.map((detail) => (
                            <div
                              key={detail.name}
                              className="template_block"
                            >
                              <div className="template_title_area">
                                {
                                  detail.color && (
                                    <div
                                      className="template_title_color"
                                      style={{
                                        backgroundColor: detail.color,
                                      }}
                                    />
                                  )
                                }
                                <div className="template_title">
                                  {detail.name}
                                </div>
                              </div>
                              {
                                detail.description ? (
                                  <div className="template_description">
                                    {
                                      detail.description.split("\n").map((v) => (
                                        <div>
                                          {v}
                                        </div>
                                      ))
                                    }
                                  </div>
                                ) : (
                                  <></>
                                )
                              }
                              {
                                (detail.permission.viewable.teams.length || detail.permission.viewable.members.length) ? (
                                  <>
                                    <div className="template_detail">
                                      <div className="template_detail_title">
                                        プロジェクト表示チーム・メンバー：
                                      </div>
                                      {
                                        detail.permission.viewable.teams.map((team) => (
                                          <div
                                            style={{
                                              border: "solid 1px #CCCCCC",
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                padding: "8px",
                                                borderBottom: "solid 1px #CCCCCC",
                                                backgroundColor: "#EEEEEE",
                                              }}
                                            >
                                              <div>
                                                {`チーム「${team.name}」のマネージャー`}
                                              </div>
                                            </div>
                                            <div
                                              className="template_tips"
                                              style={{
                                                padding: "8px",
                                              }}
                                            >
                                              {
                                                task.taskProjectTemplateSetting?.teams.find((v) => v.id === team.id)?.managers.map((member) => (
                                                  <div
                                                    className="template_tip"
                                                    key={`viewable_team_member_${member.id}`}
                                                  >
                                                    {member.name}
                                                  </div>
                                                ))
                                              }
                                            </div>
                                          </div>
                                        ))
                                      }
                                      <div className="template_tips">
                                        {
                                          detail.permission.viewable.members.map((member) => (
                                            <div
                                              key={`viewable_member_${member.name}`}
                                              className="template_tip"
                                            >
                                              {member.name}
                                            </div>
                                          ))
                                        }
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )
                              }
                              {
                                (detail.permission.usable.teams.length || detail.permission.usable.members.length) ? (
                                  <>
                                    <div className="template_detail">
                                      <div className="template_detail_title">
                                        プロジェクト参加チーム・メンバー：
                                      </div>
                                      {
                                        detail.permission.usable.teams.map((team) => (
                                          <div
                                            style={{
                                              border: "solid 1px #CCCCCC",
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                padding: "8px",
                                                borderBottom: "solid 1px #CCCCCC",
                                                backgroundColor: "#EEEEEE",
                                              }}
                                            >
                                              <div>
                                                {`チーム「${team.name}」のメンバー`}
                                              </div>
                                            </div>
                                            <div
                                              className="template_tips"
                                              style={{
                                                padding: "8px",
                                              }}
                                            >
                                              {
                                                task.taskProjectTemplateSetting?.teams.find((v) => v.id === team.id)?.members.map((member) => (
                                                  <div
                                                    className="template_tip"
                                                    key={`usable_team_member_${member.id}`}
                                                  >
                                                    {member.name}
                                                  </div>
                                                ))
                                              }
                                            </div>
                                          </div>
                                        ))
                                      }
                                      <div className="template_tips">
                                        {
                                          detail.permission.usable.members.map((member) => (
                                            <div
                                              key={`usable_member_${member.name}`}
                                              className="template_tip"
                                            >
                                              {member.name}
                                            </div>
                                          ))
                                        }
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )
                              }
                              {
                                detail.labels.length ? (
                                  <>
                                    <div className="template_detail">
                                      <div className="template_detail_title">
                                        業務：
                                      </div>
                                      <div className="template_tips">
                                        {
                                          detail.labels.map((label) => (
                                            <div
                                              key={`${detail.name}_${label.name}`}
                                              className="template_tip"
                                            >
                                              {label.name}
                                            </div>
                                          ))
                                        }
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )
                              }
                              <div
                                className="template_button_area"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "right",
                                  gap: "8px",
                                }}
                              >
                                <button
                                  type="button"
                                  onClick={() => deleteTemplate(detail?.id || 0, `ユーザーテンプレート:${detail.name}`)}
                                  style={{
                                    backgroundColor: "#C61616",
                                    border: "1px solid #C61616",
                                  }}
                                >
                                  削除する
                                </button>
                                <button
                                  type="button"
                                  onClick={() => clickSelect(detail)}
                                >
                                  選択する
                                </button>
                              </div>
                            </div>
                          ))
                        }
                        {
                          !!selectList.length && (
                            <div className="button_area">
                              <button
                                type="button"
                                className="button"
                                onClick={createTemplate}
                              >
                                <FontAwesomeIcon icon={['fas', 'plus']} />
                                &nbsp;
                                テンプレートを新規作成する
                              </button>
                            </div>
                          )
                        }
                      </>
                      {
                        !selectList.length && step === "custom" ? (
                          <>
                            <div className="no_data_area">
                              <div className="no_data">
                                テンプレートはありません
                              </div>
                              <div className="button_area">
                                <button
                                  type="button"
                                  className="button"
                                  onClick={createTemplate}
                                >
                                  <FontAwesomeIcon icon={['fas', 'plus']} />
                                  &nbsp;
                                  テンプレートを新規作成する
                                </button>
                              </div>
                            </div>
                          </>
                        ) : (
                          <></>
                        )
                      }
                    </div>
                  </>
                )
              }
            </>
          )
        }
      </>
    </Modal>
  )
}

CreateProjectModal.defaultProps = {
  deleteCallback: undefined,
}

export default CreateProjectModal
